export default  {
    name: "Google Traffic",
    mapLayerIcon: "/mapicons/traffic.png",
    defaultOn: false,
    showOnMap: true,
    publishLayer: "tasWebapp.map.enable"
}
